module.exports = __webpack_public_path__ + "static/media/landing-page-broker.06afc68d.webp";